//this is our header component
<template>
  <div id="footer" class="small-container">
    <div class="footer">
      <p></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style>
.small-container {
  max-width: 900px;
}

.footer {
  text-align: center;
  margin-top: 250px;
}
</style>
